<template>
   <div v-loading="loading">
      <div class="search-wrapper">
         <el-form :inline="true" v-model="queryForm">
            <el-form-item label="类型">
               <el-select v-model="queryForm.type">
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="状态">
               <el-select v-model="queryForm.status">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option label="已发布" :value="1"></el-option>
                  <el-option label="未发布" :value="2"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button type="primary" @click="queryList">搜索</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="clickAddition">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="listData">
            <el-table-column align="center" label="成就标识" prop="badgeId"></el-table-column>
            <el-table-column align="center" label="名称" prop="badgeName"></el-table-column>
            <el-table-column align="center" label="勋章图" min-width="200">
               <template scope="{row}">
                  <div class="flex-row-center margin-bottom-10">
                     <img class="table-img" :src="row.homeAirdropImage" alt="勋章图">
                     <img class="table-img" :src="row.homeAirdropImageNew" alt="首页弹窗">
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="达成类型">
               <template scope="{row}">{{ handleBadgeType(row) }}</template>
            </el-table-column>
            <el-table-column align="center" label="达成条件">
               <template scope="{row}">{{ handleReachCondition(row) }}</template>
            </el-table-column>
            <el-table-column align="center" label="H5链接" prop="clickLink" min-width="120"></el-table-column>
            <el-table-column align="center" label="Scheme链接" prop="newClickLink" min-width="120"></el-table-column>
            <el-table-column align="center" label="有效时间" width="180">
               <template scope="{row}">{{ handleEffectiveTime(row) }}</template>
            </el-table-column>
            <el-table-column align="center" label="状态" width="80">
               <template scope="{row}">{{ row.status == 1 ? '已发布' : '未发布' }}</template>
            </el-table-column>
            <el-table-column align="center" label="最近操作时间">
               <template scope="{row}">{{ $util.dateFormat(new Date(row.updateTime)) }}</template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180" fixed="right">
               <template scope="{row}">
                  <el-button v-if="row.status == 1" type="text" @click="clickDetail(row)">详情</el-button>
                  <el-button v-if="row.status == 2" type="text" @click="clickEdit(row)">编辑</el-button>
                  <el-button v-if="row.status == 2" type="text" @click="clickPublish(row)">发布</el-button>
                  <el-button v-if="row.status == 1" type="text" @click="clickRevoke(row)">撤销</el-button>
                  <el-button v-if="row.status == 2" type="text" style="color: red;" @click="clickDelete(row)">
                     删除
                  </el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination v-show="total > 0" layout="prev, pager, next" :current-page="queryForm.pageNum"
            :page-size='queryForm.pageSize' :total="total" @current-change="changeCurrentPage">
         </el-pagination>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         typeOptions: [
            { label: '全部', value: 0 },
            { label: '按学期', value: 1 },
            { label: '按时间', value: 2 },
            { label: '按达成学期目标', value: 3 },
            { label: '按入学年份', value: 4 },
         ],
         queryForm: {
            type: 0,
            status: 0,
            pageNum: 1,
            pageSize: 20,
         },
         total: 1,
         listData: [1]
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      // 查询列表
      queryList() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/badge/config/list',
            method: 'POST',
            body: JSON.stringify(this.queryForm)
         }).then((res) => {
            this.total = res.data.data.count || 0;
            this.listData = res.data.data.badgeModels || [];
         }).catch((err) => {
            this.total = 0;
            this.listData = [];
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送发布或撤销
      sendStatus(id, status) {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/badge/config/status',
            method: 'POST',
            body: JSON.stringify({ id, status })
         }).then((res) => {
            if (res.data.error === 10000) {
               this.queryList();
               this.$util.successMsg(res.data.message);
            } else {
               this.$util.errorMsg(res.data.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送删除
      sendDelete(id) {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/badge/config/del',
            method: 'POST',
            body: JSON.stringify({ id })
         }).then((res) => {
            if (res.data.error === 10000) {
               this.queryList();
               this.$util.successMsg(res.data.message);
            } else {
               this.$util.errorMsg(res.data.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         })
      },
      // 点击新增按钮
      clickAddition() {
         this.$router.push({
            path: '/yunying/advertising/pingan/medal/config',
            query: { type: this.queryForm.type, actionType: 'add' }
         })
      },
      // 点击详情
      clickDetail(row) {
         this.$router.push({
            path: '/yunying/advertising/pingan/medal/config',
            query: { type: row.badgeType, actionType: 'detail', id: row.id }
         })
      },
      // 点击编辑
      clickEdit(row) {
         this.$router.push({
            path: '/yunying/advertising/pingan/medal/config',
            query: { type: row.badgeType, actionType: 'edit', id: row.id }
         })
      },
      // 点击发布
      clickPublish(row) {
         this.$confirm('是否确定发布？', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.sendStatus(row.id, 1);
         }).catch(() => { });
      },
      // 点击撤销
      clickRevoke(row) {
         this.$confirm('是否确定撤销？', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.sendStatus(row.id, 2);
         }).catch(() => { });
      },
      // 点击删除
      clickDelete(row) {
         this.$confirm('是否确定删除？', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.sendDelete(row.id)
         }).catch(() => { });
      },
      // 切换当前页码
      changeCurrentPage(val) {
         this.queryForm.pageNum = val;
         this.queryList();
      },
      // 处理达成类型
      handleBadgeType(row) {
         const option = this.typeOptions.find((item) => item.value === row.badgeType);
         return option ? option.label : '';
      },
      // 处理达成条件
      handleReachCondition(row) {
         if (row.badgeType == 1 && row.runMilestoneRuleDTO) {
            const lengthLimit = row.runMilestoneRuleDTO.lengthLimit || 0;
            return `学期内跑步${lengthLimit / 1000}公里`;
         } else if (row.badgeType == 2 && row.specialDateRuleDTO) {
            const dto = row.specialDateRuleDTO;
            return `${dto.specialStartDate}-${dto.specialEndDate}跑步${dto.timesLimit || 0}次`;
         } else if (row.badgeType == 3 && row.reachSemesterGoalRuleDTO) {
            const dto = row.reachSemesterGoalRuleDTO;
            return `${dto.startDate}-${dto.endDate}内最长的学期`;
         } else if (row.badgeType == 4 && row.firstRunCaid) {
            return `入学年份${row.firstRunCaid.caid}的学生，首次跑步获得`
         }
      },
      // 处理有效时间
      handleEffectiveTime(row) {
         if (row.startTime && row.endTime) {
            return this.$util.dateFormat(new Date(row.startTime)) + ' - ' + this.$util.dateFormat(new Date(row.endTime));
         }
         return '';
      }
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// MedalConfiguration.vue?426ad269